// import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Logisticcompaniesinpune() {



const cardData = {


    keyword: "Logistics Companies in Pune",

    headingDescription: "SSK Logistic supports businesses searching for logistics companies in Pune with organized freight movement, cargo transportation, industrial logistics, commercial distribution, warehouse transfers, supply chain transportation, and third-party logistics support. The service is structured for manufacturers, distributors, retailers, wholesalers, corporate businesses, industrial units, and other organizations that need coordinated movement of goods from Pune to important business destinations across Maharashtra and India. SSK Logistic combines practical route planning, vehicle coordination, shipment scheduling, cargo handling support, and delivery management to help businesses maintain smoother transportation operations for both recurring logistics requirements and individual consignments.",

    topPlaces: [
        {
            title: "Pune to Chakan Industrial Logistics",
            description: "SSK Logistic supports industrial logistics from Pune to Chakan for automotive manufacturers, factories, warehouses, suppliers, and industrial businesses. Transportation can be coordinated for machinery, components, raw materials, finished goods, and recurring factory dispatches according to operational schedules."
        },
        {
            title: "Pune to Bhiwandi Warehouse Logistics",
            description: "Warehouse logistics from Pune to Bhiwandi helps businesses move commercial inventory, distribution stock, industrial materials, and packaged goods toward one of Maharashtra's major warehousing centers. SSK Logistic coordinates suitable transportation and delivery schedules for business consignments."
        },
        {
            title: "Pune to Mumbai Cargo Transportation",
            description: "Cargo transportation between Pune and Mumbai supports manufacturers, distributors, retailers, and corporate businesses moving commercial inventory and industrial consignments. SSK Logistic manages transportation coordination according to cargo requirements, destination points, and planned delivery schedules."
        },
        {
            title: "Pune to Nashik Freight Logistics",
            description: "Freight logistics from Pune to Nashik provides transportation support for industrial goods, machinery, commercial inventory, raw materials, and distribution consignments. SSK Logistic coordinates practical routes and suitable transportation arrangements for businesses operating between these markets."
        },
        {
            title: "Pune to Ahmedabad Supply Chain Logistics",
            description: "Supply chain logistics from Pune to Ahmedabad supports businesses requiring interstate movement of industrial materials, finished products, machinery, and commercial stock. SSK Logistic coordinates transportation as part of wider supplier, warehouse, manufacturing, and distribution requirements."
        },
        {
            title: "Pune to Surat Commercial Logistics",
            description: "Commercial logistics between Pune and Surat is suitable for traders, distributors, manufacturers, and retailers moving inventory, textile-related goods, equipment, and business consignments. SSK Logistic provides route-focused transportation coordination for planned commercial shipments."
        },
        {
            title: "Pune to Hyderabad Cargo Logistics",
            description: "Cargo logistics from Pune to Hyderabad helps businesses manage interstate transportation of machinery, commercial goods, industrial materials, and warehouse stock. SSK Logistic plans transportation according to shipment size, route requirements, destination, and expected delivery schedule."
        },
        {
            title: "Pune to Indore Logistics Transportation",
            description: "Logistics transportation from Pune to Indore supports businesses moving commercial inventory, industrial supplies, finished products, machinery, and other freight. SSK Logistic coordinates vehicle requirements and delivery planning for businesses operating across this interstate route."
        },
        {
            title: "Pune to Bengaluru Industrial Logistics",
            description: "Industrial logistics from Pune to Bengaluru supports manufacturers, suppliers, technology businesses, and commercial enterprises transporting equipment, components, products, and industrial materials. SSK Logistic provides coordinated transportation planning for long-distance business cargo."
        },
        {
            title: "Pune to Delhi NCR Freight Transportation",
            description: "Freight transportation from Pune to Delhi NCR is suitable for businesses handling larger interstate consignments, commercial inventory, machinery, and industrial goods. SSK Logistic coordinates long-distance logistics requirements with practical route, vehicle, and delivery planning."
        }
    ],

    "services": [
        {
            "name": "Logistics Companies Pune",
            "description": "SSK Logistic supports businesses searching for logistics companies Pune with transportation, cargo movement, freight coordination, warehouse transfers, and commercial distribution services. Solutions can be arranged for local, regional, and interstate business routes according to shipment requirements."
        },
        {
            "name": "Logistics Company in Pune",
            "description": "Businesses looking for a logistics company in Pune can approach SSK Logistic for organized movement of industrial goods, commercial inventory, freight, machinery, and cargo. Transportation arrangements are planned around destination, shipment type, vehicle suitability, and delivery schedules."
        },
        {
            "name": "Logistics Service Providers Pune",
            "description": "SSK Logistic serves as a logistics service provider for businesses requiring coordinated transportation, freight movement, warehouse transfers, and cargo delivery. Logistics service providers Pune requirements can be structured for recurring dispatches, commercial distribution, and interstate cargo movement."
        },
        {
            "name": "Logistics Providers in Pune",
            "description": "Companies searching for logistics providers in Pune can use SSK Logistic for transportation planning, cargo coordination, industrial freight movement, commercial deliveries, and distribution support. The service can accommodate both scheduled business routes and individual shipment requirements."
        },
        {
            "name": "Logistics Services Pune",
            "description": "SSK Logistic provides logistics services Pune businesses can use for industrial transportation, commercial cargo movement, warehouse transfers, freight delivery, and interstate distribution. Each movement is coordinated according to cargo characteristics, destination requirements, and planned schedules."
        },
        {
            "name": "Best Logistics Companies Pune",
            "description": "For businesses researching best logistics companies Pune, SSK Logistic offers structured logistics support covering cargo transportation, industrial freight, commercial distribution, warehouse movement, and route planning. Services are designed around practical business transportation requirements."
        },
        {
            "name": "Top Logistics Companies Pune",
            "description": "Businesses comparing top logistics companies Pune can consider SSK Logistic for organized freight transportation, cargo movement, supply chain support, and commercial logistics coordination. Transportation arrangements can be adapted to shipment size, route distance, and delivery requirements."
        },
        {
            "name": "Freight Logistics Companies Pune",
            "description": "SSK Logistic supports freight logistics companies Pune requirements through coordinated movement of industrial goods, commercial consignments, machinery, raw materials, and larger freight loads. Route and vehicle planning are structured according to the specific requirements of each shipment."
        },
        {
            "name": "Cargo Logistics Companies Pune",
            "description": "Cargo logistics companies Pune requirements can be supported by SSK Logistic through planned cargo pickup, transportation, route coordination, and destination delivery. The service is suitable for manufacturers, distributors, traders, warehouses, and commercial businesses."
        },
        {
            "name": "Industrial Logistics Companies Pune",
            "description": "SSK Logistic supports industrial logistics companies Pune requirements for manufacturing units and industrial businesses transporting raw materials, components, machinery, equipment, and finished goods. Logistics arrangements can be coordinated around factory dispatches and operational schedules."
        },
        {
            "name": "Commercial Logistics Companies Pune",
            "description": "Commercial logistics companies Pune services from SSK Logistic assist retailers, wholesalers, distributors, traders, and corporate businesses with planned transportation of inventory and commercial consignments. Delivery coordination is structured around business schedules and destination requirements."
        },
        {
            "name": "Transportation Logistics Companies Pune",
            "description": "SSK Logistic provides transportation logistics companies Pune solutions for businesses requiring organized movement between suppliers, factories, warehouses, distribution centers, and customer locations. Route planning and vehicle coordination help maintain a structured flow of commercial cargo."
        },
        {
            "name": "Supply Chain Companies Pune",
            "description": "Supply chain companies Pune requirements can be supported by SSK Logistic through transportation coordination between manufacturing facilities, warehouses, suppliers, distributors, and market destinations. The service focuses on the transportation component of business supply chain operations."
        },
        {
            "name": "Third Party Logistics Companies Pune",
            "description": "SSK Logistic supports third party logistics companies Pune requirements for businesses outsourcing transportation and distribution activities. Services can include recurring freight movement, warehouse transfers, cargo delivery, and scheduled transportation between multiple business locations."
        },
        {
            "name": "Warehouse Logistics Companies Pune",
            "description": "Warehouse logistics companies Pune services from SSK Logistic support movement between warehouses, factories, distribution centers, and commercial locations. Transportation can be planned for stock transfers, inventory movement, dispatch requirements, and recurring warehouse logistics operations."
        },
        {
            "name": "Cargo Transportation Companies Pune",
            "description": "SSK Logistic assists businesses searching for cargo transportation companies Pune with organized movement of commercial products, industrial materials, machinery, equipment, and warehouse stock. Transportation plans are developed according to cargo quantity, vehicle requirements, destination, and delivery schedules."
        },
        {
            "name": "Logistics Solutions Companies Pune",
            "description": "Logistics solutions companies Pune requirements can be addressed through SSK Logistic with transportation planning suited to individual business operations. Services can cover cargo movement, freight transportation, warehouse transfers, commercial distribution, and recurring route requirements."
        },
        {
            "name": "Reliable Logistics Companies Pune",
            "description": "SSK Logistic supports businesses comparing reliable logistics companies Pune by providing structured transportation for freight, cargo, industrial materials, commercial inventory, and warehouse consignments. Consistent coordination helps businesses manage recurring transportation requirements more systematically."
        },
        {
            "name": "Trusted Logistics Companies Pune",
            "description": "Businesses looking for trusted logistics companies Pune can coordinate with SSK Logistic for planned cargo movement, freight transportation, industrial deliveries, and commercial distribution. Service arrangements can be tailored to route schedules, shipment requirements, and business priorities."
        },
        {
            "name": "Professional Logistics Companies Pune",
            "description": "SSK Logistic provides professional logistics companies Pune services focused on organized transportation, cargo coordination, freight movement, and delivery planning. Businesses can use the service for both recurring logistics programs and individual commercial consignments."
        },
        {
            "name": "Local Logistics Companies Pune",
            "description": "Local logistics companies Pune requirements can be managed through SSK Logistic for transportation between factories, warehouses, markets, distribution centers, and nearby business locations. Local cargo movement can be arranged for scheduled stock transfers and regular commercial deliveries."
        },
        {
            "name": "Corporate Logistics Companies Pune",
            "description": "SSK Logistic supports corporate logistics companies Pune requirements with transportation for commercial inventory, equipment, supplies, documents, materials, and distribution consignments. Service schedules can be coordinated around corporate operations and recurring business transportation needs."
        },
        {
            "name": "Logistics Partner Pune",
            "description": "SSK Logistic can work as a logistics partner Pune businesses rely on for regular freight movement, cargo transportation, warehouse transfers, industrial deliveries, and interstate distribution. Logistics arrangements can be scaled around recurring routes and changing shipment requirements."
        },
        {
            "name": "Logistics Management Companies Pune",
            "description": "Logistics management companies Pune requirements can be supported by SSK Logistic through transportation scheduling, route coordination, vehicle planning, cargo movement, and delivery management. The approach helps businesses organize multiple transportation activities through a coordinated logistics process."
        },
        {
            "name": "Logistics Company Near Pune",
            "description": "Businesses searching for a logistics company near Pune can use SSK Logistic for local, regional, and interstate cargo transportation. The service supports manufacturing units, warehouses, distributors, commercial businesses, and industrial customers with practical logistics coordination."
        }
    ],

    "tableData": [
        ["Logistics Companies Pune", "Logistics Company in Pune"],
        ["Logistics Service Providers Pune", "Logistics Providers in Pune"],
        ["Logistics Services Pune", "Best Logistics Companies Pune"],
        ["Top Logistics Companies Pune", "Freight Logistics Companies Pune"],
        ["Cargo Logistics Companies Pune", "Industrial Logistics Companies Pune"],
        ["Commercial Logistics Companies Pune", "Transportation Logistics Companies Pune"],
        ["Supply Chain Companies Pune", "Third Party Logistics Companies Pune"],
        ["Warehouse Logistics Companies Pune", "Cargo Transportation Companies Pune"],
        ["Logistics Solutions Companies Pune", "Reliable Logistics Companies Pune"],
        ["Trusted Logistics Companies Pune", "Professional Logistics Companies Pune"],
        ["Local Logistics Companies Pune", "Corporate Logistics Companies Pune"],
        ["Logistics Partner Pune", "Logistics Management Companies Pune"],
        ["Logistics Company Near Pune", "Logistics Companies in Pune"]
    ],

    whychoose: [
        {
            WhyChooseheading: "Coordinated Logistics Operations",
            WhyChoosedescription: "SSK Logistic organizes transportation requirements through practical route planning, vehicle coordination, cargo scheduling, and delivery management, helping businesses maintain a more systematic approach to logistics operations."
        },
        {
            WhyChooseheading: "Industrial and Commercial Coverage",
            WhyChoosedescription: "Manufacturers, distributors, retailers, warehouses, traders, and corporate businesses can coordinate transportation for industrial materials, commercial inventory, machinery, finished goods, and other business consignments."
        },
        {
            WhyChooseheading: "Support for Multiple Shipment Types",
            WhyChoosedescription: "Logistics arrangements can be planned for freight, cargo, warehouse stock, machinery, raw materials, commercial products, and recurring distribution loads according to shipment characteristics and destination requirements."
        },
        {
            WhyChooseheading: "Local to Interstate Transportation",
            WhyChoosedescription: "SSK Logistic supports routes within Pune and surrounding industrial regions as well as long-distance transportation to major commercial and manufacturing destinations across Maharashtra and other parts of India."
        },
        {
            WhyChooseheading: "Recurring Route Management",
            WhyChoosedescription: "Businesses with regular dispatches can coordinate recurring transportation requirements with SSK Logistic, making it easier to manage repeated warehouse transfers, supplier movements, factory dispatches, and distribution routes."
        },
        {
            WhyChooseheading: "Practical Supply Chain Support",
            WhyChoosedescription: "SSK Logistic assists with the transportation side of supply chain operations by coordinating movement between suppliers, manufacturing facilities, warehouses, distributors, and customer destinations."
        },
        {
            WhyChooseheading: "Flexible Logistics Planning",
            WhyChoosedescription: "Transportation arrangements can be adapted to cargo volume, destination, route distance, vehicle requirements, and scheduling priorities, allowing businesses to coordinate logistics according to their operational needs."
        },
        {
            WhyChooseheading: "Business-Focused Service",
            WhyChoosedescription: "SSK Logistic focuses on commercial and industrial transportation requirements, providing coordinated logistics support that considers business schedules, shipment priorities, delivery locations, and recurring cargo movement needs."
        }
    ]

};













const faqData = [
    {
        question: "What logistics services does SSK Logistic offer in Pune?",
        answer: "SSK Logistic assists businesses with organized goods transportation from Pune to different destinations, supporting commercial and industrial shipments according to cargo type, vehicle requirements, route, and delivery schedule."
    },
    {
        question: "Can SSK Logistic arrange cargo transportation from Pune to other cities?",
        answer: "Businesses can coordinate shipments from Pune to cities such as Mumbai, Nashik, Nagpur, Ahmedabad, Surat, Vadodara, Indore, Bengaluru, Hyderabad, Chennai, Delhi, Jaipur, and other destinations across India."
    },
    {
        question: "Which business goods can be transported by SSK Logistic?",
        answer: "Transportation can be considered for industrial materials, machinery, equipment, commercial inventory, packaged goods, raw materials, finished products, supplies, and other appropriate business consignments based on their handling needs."
    },
    {
        question: "Does SSK Logistic provide transportation for recurring shipments?",
        answer: "For businesses with frequent cargo movement, transportation schedules can be discussed around recurring routes, pickup requirements, shipment quantities, vehicle capacities, and expected delivery timelines."
    },
    {
        question: "How is the transportation vehicle selected for a logistics shipment?",
        answer: "The vehicle requirement is determined by reviewing factors such as cargo weight, size, volume, quantity, loading conditions, material characteristics, travel distance, and delivery destination."
    },
    {
        question: "Can SSK Logistic handle Pune to Mumbai goods movement?",
        answer: "Pune to Mumbai transportation is available for suitable business consignments such as commercial stock, industrial materials, equipment, machinery, supplies, and packaged goods requiring movement between the two cities."
    },
    {
        question: "Does SSK Logistic handle interstate transportation from Pune?",
        answer: "Interstate cargo movement can be planned toward destinations in Gujarat, Madhya Pradesh, Karnataka, Telangana, Tamil Nadu, Rajasthan, Delhi, and other regions according to the shipment and transportation requirements."
    },
    {
        question: "Can manufacturers and distributors use SSK Logistic for logistics support?",
        answer: "Manufacturing companies, distributors, suppliers, warehouses, and other commercial businesses can utilize transportation support for moving materials, finished goods, machinery, equipment, stock, and other business consignments."
    },
    {
        question: "Can logistics transportation be customized for individual business requirements?",
        answer: "Yes, transportation arrangements can be discussed around the exact pickup location, destination, cargo specifications, quantity, loading requirements, vehicle type, delivery timeframe, and frequency of movement."
    },
    {
        question: "What details should I provide when contacting SSK Logistic in Pune?",
        answer: "Providing the pickup address or area, delivery destination, cargo type, approximate weight or quantity, preferred vehicle, loading details, and expected delivery schedule helps in discussing a suitable logistics transportation arrangement."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Saurabh Jagtap",
        feedback: "We were looking for transportation support for commercial stock moving from Pune to Vadodara. SSK Logistic understood our shipment details and coordinated the vehicle requirement in a practical and organized manner.",
        rating: 5
    },
    {
        id: 2,
        name: "Miss. Manasi Desai",
        feedback: "SSK Logistic assisted our business with transporting materials from Pune to Bengaluru. The coordination was straightforward, and the team kept the transportation requirements clear from the beginning.",
        rating: 5
    }
];














    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Logistics Company Pune",
            link: "Logistics-Company-Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Best Logistics Companies in Pune",
            link: "Best-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Top Logistics Companies in Pune",
            link: "Top-Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Logistics in Pune",
            link: "Logistics-in-Pune",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Transport Company in Pune",
            link: "Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "Logistics Companies in Pune",
            link: "Logistics-Companies-in-Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Transporters in Pune",
            link: "Transporters-in-Pune",
        },
        {
            place: "/images/keyword/8.jpg",
            text: "Pune Transport Office",
            link: "Pune-Transport-Office",
        },
        {
            place: "/images/keyword/9.jpg",
            text: "Best Logistics Company in Pune",
            link: "Best-Logistics-Company-in-Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Goods Transport Services in Pune",
            link: "Goods-Transport-Services-in-Pune",
        },
        {
            place: "/images/keyword/11.jpg",
            text: "Transportation Services for Industrial",
            link: "Transportation-Services-for-Industrial",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Pune Transport Service for Company",
            link: "Pune-Transport-Service-for-Company",
        },
        {
            place: "/images/keyword/13.jpg",
            text: "Industrial Transport Company in Pune",
            link: "Industrial-Transport-Company-in-Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: "Supply Chain Management Company in Pune",
            link: "Supply-Chain-Management-Company-in-Pune",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Cargo Transportation Company in Pune",
            link: "Cargo-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/16.jpg",
            text: "Commercial Transportation Services in Pune",
            link: "Commercial-Transportation-Services-in-Pune",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Container Transportation Company in Pune",
            link: "Container-Transportation-Company-in-Pune",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Third Party Logistics Company in India",
            link: "Third-Party-Logistics-Company-in-India",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Transport Service",
            link: "Pune-to-Mumbai-Transport-Service",
        },
        {
            place: "/images/keyword/20.jpg",
            text: "Pune to Bangalore Transport Service",
            link: "Pune-to-Bangalore-Transport-Service",
        },
        {
            place: "/images/keyword/21.jpg",
            text: "Pune to Hyderabad Transport Service",
            link: "Pune-to-Hyderabad-Transport-Service",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Pune to Chennai Transport Service",
            link: "Pune-to-Chennai-Transport-Service",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Pune to Delhi Transport Service",
            link: "Pune-to-Delhi-Transport-Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Pune to Ahmedabad Transport Service",
            link: "Pune-to-Ahmedabad-Transport-Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Pune to Surat Transport Service",
            link: "Pune-to-Surat-Transport-Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Pune to Nashik Transport Service",
            link: "Pune-to-Nashik-Transport-Service",
        },
        {
            place: "/images/keyword/27.jpg",
            text: "Pune to Nagpur Transport Service",
            link: "Pune-to-Nagpur-Transport-Service",
        },
        {
            place: "/images/keyword/28.jpg",
            text: "Pune to Kolhapur Transport Service",
            link: "Pune-to-Kolhapur-Transport-Service",
        },
    ];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Logistics Companies in Pune",
  "image": "https://ssklogistics.in/assets/images/logistics-companies-in-pune.webp",
  "description": "SSK Logistics provides structured logistics support for businesses searching for logistics companies in Pune for commercial, industrial, freight and cargo transportation requirements. Logistics companies Pune services can help manufacturers, distributors, wholesalers, retailers, warehouses and corporate businesses coordinate the movement of goods between factories, suppliers, storage facilities, distribution centres and customer locations. As a logistics company in Pune, SSK Logistics can assist with transportation planning based on cargo type, shipment volume, destination and delivery schedule. Logistics service providers Pune can support businesses with regular transportation requirements, scheduled dispatches and project-based goods movement, while logistics providers in Pune can coordinate suitable vehicles for different commercial and industrial consignments. Logistics services Pune can include local, regional and interstate transportation support depending on the route and business requirement. Best logistics companies Pune searches commonly relate to dependable goods movement, suitable transportation arrangements and consistent service coordination, while top logistics companies Pune requirements may involve freight, cargo and industrial transportation. Freight logistics companies Pune can support larger commercial consignments and business freight movement, while cargo logistics companies Pune can assist with organized transportation of different types of goods. Industrial logistics Pune services can support manufacturers and industrial businesses with movement of raw materials, machinery, equipment and finished products. SSK Logistics focuses on practical transportation coordination and business-oriented logistics support for companies operating across Pune and connected destinations.",
  "brand": {
    "@type": "Brand",
    "name": "SSK Logistics"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Contact for Logistics Service Pricing",
    "availability": "https://schema.org/InStock",
    "url": "https://ssklogistics.in/logistics-companies-in-pune"
  }
};






    return (
        <div>

<Helmet>
  <title>
    Logistics Companies in Pune | Freight, Cargo & Industrial Logistics Services | +91 9876543210
  </title>

  <meta
    name="description"
    content="SSK Logistics provides commercial, freight, cargo and industrial logistics services in Pune for manufacturers, distributors, warehouses and businesses."
  />

  <meta
    name="keywords"
    content="Logistics Companies in Pune, logistics companies pune, logistics company in pune, logistics service providers pune, logistics providers in pune, logistics services pune, best logistics companies pune, top logistics companies pune, freight logistics companies pune, cargo logistics companies pune, industrial logistics companies Pune, commercial logistics companies Pune, logistics provider Pune, logistics service provider Pune, logistics solutions Pune, logistics transportation Pune, freight transportation Pune, cargo transportation Pune, industrial transportation Pune, commercial transportation Pune, goods transportation Pune, goods transport company Pune, warehouse logistics Pune, warehouse transportation Pune, supply chain logistics Pune, business logistics Pune, corporate logistics Pune, B2B logistics Pune, local logistics services Pune, regional logistics Pune, interstate logistics Pune, reliable logistics companies Pune, professional logistics company Pune, freight services Pune, cargo services Pune, industrial logistics Pune, commercial logistics services Pune, logistics partner Pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
            <section className="page-banner">
                <div className="page-banner-container">
                    <h2>
                        {cardData.keyword}
                    </h2>
                </div>
            </section>








            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/6.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >SSK Logistics
                                : {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="cab-service-list">
                                {cardData.services.map((service, index) => (
                                    <div className="cab-service-row" key={index}>
                                        <div className="cab-service-details">
                                            <h4>{service.name}</h4>
                                            <span className="cab-service-line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="cab-service-arrow">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            {/* <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div> */}
                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>


                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>SSK Logistics</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">




                                        <div className="row twm-faq-section-1 m-b30">


                                            <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                                <div className="twm-faq-info-wrap">

                                                    <div className="section-head left">
                                                        <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For SSK Logistics </h2>
                                                    </div>


                                                    <div className="twm-faq-info">
                                                        <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                            <FaqSection
                                                                title=""
                                                                subtitle=""
                                                                items={faqData}
                                                            />

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919876543210 " className="pc-call">+91 9876543210 </a>
                                        </div>


                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919876543210 "
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919876543210 " className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:info@ssklogistics.in" className="pc-email">
                                            info@ssklogistics.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>SSK Logistics</strong><br />
                                            ViOffice no. 109 first Floor, Ashoka Plaza, above dominos Pizza, Beside Hyatt Hotel, Viman Nagar, Pune- 411014




                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Logisticcompaniesinpune;